import { useCallback, useState } from 'react';
import { GenericForm } from 'src/components/GenericForm/generic-form';
import { LandingPageTabs } from 'src/pages/Settings/memberships/components/landing-page-tab/landing-page-tabs';
import type { LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { useConfigFormSaveSlots } from 'src/pages/Settings/memberships/hooks/use-config-form-save-slots';
import { useReportFormValues } from 'src/pages/Settings/memberships/hooks/use-report-form-values';
import { useSeededForm } from 'src/pages/Settings/memberships/hooks/use-seeded-form';
import {
  type ConfigFormSaveSlots,
  LandingPageTabValues,
} from 'src/pages/Settings/memberships/types';
import { getLandingPageErrorTab } from 'src/pages/Settings/memberships/utils/get-landing-page-error-tab';

type LandingPageConfigViewFormProps = ConfigFormSaveSlots<LandingPageFormValues> & {
  data: LandingPageFormValues;
  readOnly: boolean;
  segmentLogoUrl?: string | null;
  onFormValuesChange?: (values: LandingPageFormValues) => void;
};

export const LandingPageConfigViewForm = ({
  data,
  readOnly,
  segmentLogoUrl,
  onFormValuesChange,
  onSaveRequestChange,
  onDirtyChange,
  onSubmitStateChange,
}: LandingPageConfigViewFormProps) => {
  const { formMethods } = useSeededForm(data);
  const [activeTab, setActiveTab] = useState<LandingPageTabValues>(
    LandingPageTabValues.Content,
  );

  // Otherwise the save refuses with the offending field off screen.
  const showErrorTab = useCallback(() => {
    const errorTab = getLandingPageErrorTab(formMethods.formState.errors);

    if (errorTab !== null) {
      setActiveTab(errorTab);
    }
  }, [formMethods]);

  useReportFormValues(formMethods, onFormValuesChange);
  useConfigFormSaveSlots(
    formMethods,
    { onSaveRequestChange, onDirtyChange, onSubmitStateChange },
    showErrorTab,
  );

  return (
    <GenericForm<LandingPageFormValues> formMethods={formMethods} gap={3}>
      <LandingPageTabs
        readOnly={readOnly}
        segmentLogoUrl={segmentLogoUrl}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </GenericForm>
  );
};
